<db-dialog-wrapper [dialog]="this" [width]="!!isMobile ? '100%' : (width ? width + 'px' : '500px')"
                   [withBlur]="withBlur"
                   [withBlackBlur]="withBlackBlur"
                   [hasCloseButton]="hasCloseButton" [canCloseByBackdrop]="false" [fullScreen]="!!isMobile"
                   [ngClass]="{'has-border': !!hasGradientBorder && !isMobile,}" class="{{gradientBorder ?? ''}}">
  <div class="db-notification-dialog {{mainClass}}">
    <div class="db-notification-dialog__image" *ngIf="image">
    </div>
    @if(combinedHeader){
    <div class="db-notification-dialog__animation_combined">
  <div class="db-notification-dialog__header {{textAlign}}" [innerHTML]="header"></div>
      <div class="db-notification-dialog__animation" *ngIf="showLottie">
        <ng-lottie
          [options]="lottieConfig"
          style="width: 40px; height: 40px; display: block"
        ></ng-lottie>
      </div>
    </div>
    }@else{
    <div class="db-notification-dialog__animation" *ngIf="showLottie">
      <ng-lottie
        [options]="lottieConfig"
        style="width: 101px; height: 101px; display: block"
      ></ng-lottie>
    </div>

    <div class="db-notification-dialog__header {{textAlign}}" [innerHTML]="header"></div>
    }

    <div class="db-notification-dialog__message {{textAlign}}">
      <p [innerHTML]="message"></p>
      <div class="ds-notification-gray mt20" *ngIf="hasNotice">
        <div>
          <i class="db-icon db-icon-credentials"></i>
          <p>{{ 'text_domainPurchasedNotificationMessage' | dbText }}</p>
        </div>
      </div>
      <div class="db-notification-dialog__buttons-wrap {{buttonAlign}}" *ngIf="showSuccess">
        <a class="ds-btn" *ngIf="showCancelButton" (click)="close()"><span>{{'text_cancel' | dbText | lowerCaseSpecificWords}}</span></a>
        <a class="ds-btn-{{buttonColor}}" [style.width]="buttonSize ? buttonSize : ''" [ngClass]="{'ds-btn-l': forDemo || forEcommerce}" *ngIf="!hasAdminLink" (click)="onClick($event)"><span>{{buttonText | lowerCaseSpecificWords}}</span></a>
        <a class="ds-btn-{{buttonColor}}" *ngIf="hasAdminLink" (click)="onClick($event)"
           dbWpLink [adminLink]="adminLink" [websiteId]="websiteId" target="_blank" rel="noopener"><span>{{buttonText | lowerCaseSpecificWords}}</span></a>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
